/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ fundName: NonNullable<unknown> }} Cas_Confirmation_Turn_OffInputs */

const en_cas_confirmation_turn_off = /** @type {(inputs: Cas_Confirmation_Turn_OffInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`By turning off CAS statement, ${i?.fundName} will no longer offer a Capital Account (Excel) export to its investors`)
};

/**
* | output |
* | --- |
* | "By turning off CAS statement, {fundName} will no longer offer a Capital Account (Excel) export to its investors" |
*
* @param {Cas_Confirmation_Turn_OffInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const cas_confirmation_turn_off = /** @type {((inputs: Cas_Confirmation_Turn_OffInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cas_Confirmation_Turn_OffInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_cas_confirmation_turn_off(inputs)
});